<form [formGroup]="coverageStartForm">
  <app-boomer-date-input
    [form]="coverageStartForm"
    formControlName="coverageStart"
    label="Coverage Start"
    [subscriptSizing]="subscriptSizing"
    [filter]="coverageStartDateFilter"
  >
  </app-boomer-date-input>
</form>
